import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
// local
import PresentationCardWrapper from "../../PresentationCardWrapper";
import AddressCard from "components/AddressCard";
import EmptyData from "components/EmptyData";
import {IconMapMarker} from "components/icons";
import {formatCityAscii} from "helpers/helper";

const CompanyAddresses = ({organizationDetail}) => {
    const {t} = useTranslation();

    const {visitingAddress, mailingAddress} = useMemo(() => {
      const response = {
        visitingAddress: null,
        mailingAddress: null,
      };

      if (!organizationDetail?.Company?.companyCreditReport) {
        return response;
      }

      const visitingAddressesArray =
        organizationDetail.Company.companyCreditReport.visitingAddresses;
      const mailingAddressesArray =
        organizationDetail.Company.companyCreditReport.mailingAddresses;

      if (Array.isArray(visitingAddressesArray) && visitingAddressesArray.length) {
        const address = visitingAddressesArray[0];
        response.visitingAddress = {
          address: address.visitingAddress,
          city: formatCityAscii(address.visitingTown),
          zipCode: address.visitingZip,
          country: address.visitingCountry ?? address.country,
        };
      }
      if (Array.isArray(mailingAddressesArray) && mailingAddressesArray.length) {
        const address = mailingAddressesArray[0];
        response.mailingAddress = {
          address: address.mailingAddress,
          city: formatCityAscii(address.mailingTown),
          zipCode: address.mailingZip,
          country: address.mailingCountry ?? address.country,
        };
      }
      return response;
    }, [organizationDetail]);

    const hasCreditReport = !!organizationDetail?.Company?.companyCreditReport;
    const hasAnyAddress = !!(mailingAddress || visitingAddress);

    return (
      <PresentationCardWrapper
        icon={<IconMapMarker />}
        title={t("PRESENTATION_ADDRESSES")}
        isActive={false}
        addClass="__contact-person fg2"
      >
        {hasCreditReport && hasAnyAddress ? (
          <AddressCard
            mailingAddressObject={mailingAddress}
            visitingAddressObject={visitingAddress}
          />
        ) : (
          <EmptyData />
        )}
      </PresentationCardWrapper>
    );
};

export default CompanyAddresses;
